import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../token/auth.service';

@Injectable({
    providedIn: 'root',
})
export class GuestGuard implements CanActivate, CanLoad {

    constructor(protected authService: AuthService) {}

    public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.authService.check().pipe(
            map((authenticated) => {
                if (authenticated) {
                    this.redirect(route.queryParams['redirect_uri']);
                }

                return !authenticated;
            })
        );
    }

    public canLoad(route: Route): Observable<boolean> {
        return this.canActivate(route as unknown as ActivatedRouteSnapshot);
    }

    protected redirect(redirectUri?: string): void {
        this.authService.routeAfterLogin(redirectUri);
    }

}
